import { setting } from './_setting.js';
import { user } from './_user.js';
export let modal = {
	target: null,
	prev: null,
	next: null,
	close: null,
	targetData: null,
	current: 0,
	max: 0,
	data: null,
	gameTimer: null,
	init: function( data, timer ){
		modal.data 		= data;
		modal.gameTimer = timer;
		modal.target 	= document.querySelector("#b-modal");
		modal.prev 		= modal.target.querySelector("button[data-modal-prev]");
		modal.next 		= modal.target.querySelector("button[data-modal-next]");
		modal.close 	= modal.target.querySelectorAll("[data-modal-close]");
	},
	nav: function(){
		modal.prev.removeEventListener("click", modal.dec, false);
		modal.next.removeEventListener("click", modal.inc, false);
		
		modal.prev.addEventListener("click", modal.dec, false);
		modal.next.addEventListener("click", modal.inc, false);
		const eventListenersMultiple = [
			{ elements: modal.close, type: "click", handler: modal.closeModal }
		];
		eventListenersMultiple.forEach( ( el ) => {
			el.elements.forEach( ( element )=> {
				element.removeEventListener(el.type, el.handler, false);
				element.addEventListener(el.type, el.handler, false);
			});
		});
	},
	selectData: function( id ){
		user.got.forEach( (gotId, index) => {
			//console.log(id);
			if( gotId === id){
				modal.current = index;
				modal.max = user.got.length;
				
			}
		});
		modal.data.forEach( (d, index) => {
			if( d.id === id ){
				modal.targetData = d;
			}
		});
		//console.log(modal);
		modal.makeModalContent(modal.targetData);
		//console.log(id, modal.targetData);
	},
	makeModalContent: function(data){
		modal.clearData();
		let $profile = modal.target.querySelector(".c-profile");
		$profile.querySelector("h2").innerHTML = data.initial;
		$profile.querySelector("p.job_title").innerHTML = data.job_title;
		
		let birthDay = "";
		if( data.birthday ){
			birthDay += data.birthday;
		}
		if( data.constellation ){
			if( data.birthday ){
				birthDay += '／' + data.constellation;
			}else{
				birthDay += data.constellation
			}
			
		}
		$profile.querySelector("p.birthday").innerHTML = birthDay;
		modal.target.querySelector(".img_person figure img").setAttribute("src", data.image.url + "?fm=webp");
	
		// dd に値をセットしつつ、親 dl の disable を切り替える
		const setField = ( selector, value ) => {
			const $dd = $profile.querySelector(selector);
			if( !$dd ) return;
			const $dl = $dd.closest("dl");
			const hasValue = value !== undefined && value !== null && value !== "";
			$dd.innerHTML = hasValue ? value : "";
			if( $dl ) $dl.classList.toggle("disable", !hasValue);
		};
	
		setField("dd.skill", data.skill);
		setField("dd.hobby", data.hobby);
		setField("dd.habit", data.habit);
		setField("dd.special_skill", data.special_skill);
		setField("dd.color", data.color);
	
		$profile.querySelector(".c-description p").innerHTML = data.description;
	
		setTimeout(function(){
			modal.openModal();
		}, 100);
	},
	dec: function(){
		modal.current--;
		if( modal.current < 0 ){
			modal.current = modal.max - 1;
		}
		modal.hideContent().then( ()=> {
			modal.selectData(user.got[modal.current]);
		});
	},
	inc: function(){
		modal.current++;
		if( modal.current >= modal.max ){
			modal.current = 0;
		}
		modal.hideContent().then( ()=> {
			modal.selectData(user.got[modal.current]);;
		});
	},
	hideContent: function(){
		return new Promise((resolve, reject) =>{
			let $detail = document.querySelector("#b-modal .c-person_detail");
			let $cols = $detail.querySelector(".c-cols");
			$detail.classList.add("hide");
			document.querySelector("#b-modal .modal_inner").scrollTop = 0;
			$cols.addEventListener("transitionend", function(){
				setTimeout(function(){
					resolve();
				}, 100);
			}, {
				"once": true
			})
		});
	},
	openModal: function(){
		let $html = document.documentElement;
		let $detail = document.querySelector("#b-modal .c-person_detail");
		modal.check();
		if( !user.isClear ){
			modal.gameTimer.pause();
		}
		
		if( !$html.classList.contains("show_modal") ){
			$html.classList.add("show_modal");
			modal.nav();
		}else{
			$detail.classList.remove("hide");
		}
	},
	closeModal: function(){
		let $html = document.documentElement;
		if( $html.classList.contains("show_modal") ){
			$html.classList.remove("show_modal");
			if( !user.isClear ){
				modal.gameTimer.start();
				modal.clearData();
			}
		}
	},
	check: function(){
		if( user.got.length === 1 ){
			modal.prev.classList.add("disable");
			modal.next.classList.add("disable");
		}else{
			modal.prev.classList.remove("disable");
			modal.next.classList.remove("disable");
		}
	},
	clearData: function(){
		modal.target.querySelector(".img_person figure img").setAttribute("src", "");
	}
}